export class CheckboxValueConverter {
    toView(value): string {
        return value ? value === true || value === "true" || value === "True" ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline" : "mdi-help-box";
    }
}

export class TransactionProcessingValueConverter {
    toView(value): string {
        return value ? value === true || value === "true" || value === "True" ? "mdi-alpha-c-box-outline" : "mdi-checkbox-blank-outline" : "mdi-alpha-g-box-outline";
    }
}
